export const enPortfolio = {
    "our": "OUR",
    "title": "PROJECTS",
    "subtitle": "THE RESULT OF SKILL, PRECISION, AND DEDICATION",
}

export const frPortfolio = {
    "our": "NOS",
    "title": "PROJETS",
    "subtitle": "LE RÉSULTAT DE LA COMPÉTENCE, DE LA PRÉCISION ET DE L'ENGAGEMENT",
}
export const nlPortfolio = {
    "our": "ONZE",
    "title": "PROJECTEN",
    "subtitle": "HET RESULTAAT VAN VAARDIGHEID, PRECISIE EN TOEWijding",
}
export const dePortfolio = {
    "our": "UNSERE",
    "title": "PROJEKTE",
    "subtitle": "DAS ERGEBNIS VON FÄHIGKEIT, PRÄZISION UND ENGAGEMENT",
}